<template>
<div  class=""  style="padding-top:70px;">
  <el-form ref="formBasic" :model="$socio.contatto.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">


<div class="row">
          <div class="col s4 m12"><img src="../assets/logo.png" style="height:90px;"/></div>
          <div class="col s8 m12"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
        </div>

        
    <div class="row">

      <div class="col s12" style="margin-top:12px;margin-bottom:30px;color:red;">I campi evidenziati sono obbligatori</div>

<!--    
      <div class="col s12 m6">
      <el-form-item label="Cognome" prop="cognome">
        <el-input  v-model="$socio.contatto.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nome" prop="nome">
        <el-input  v-model="$socio.contatto.row.nome"></el-input>
      </el-form-item>
      </div> 
-->
      <div class="col s12 m6">
      <el-form-item label="Email" prop="email">
        <el-input  v-model="$socio.contatto.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinserisci Email" prop="emailcheck"  class="is-required">
        <el-input  v-model="emailcheck"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6 clear">
      <el-form-item label="Data di nascita" prop="natoil" class="is-required">
        <el-date-picker v-model="$socio.contatto.row.natoil" type="date" placeholder="Indica la tua data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Sesso" prop="sesso">
        <el-select v-model="$socio.contatto.row.sesso"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Maschio" value="M" ></el-option>
          <el-option label="Femmina" value="F" ></el-option>
        </el-select>
      </el-form-item>
      </div> 
   

      <div class="col s12 m6">
      <el-form-item label="Nazione di nascita" prop="natonazione">
        <el-select v-model="$socio.contatto.row.natonazione"  filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nome" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>
   

      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Provincia di nascita" prop="natoprovincia">
        <el-select v-model="$socio.contatto.row.natoprovincia" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Città di nascita" prop="natoa">
        <el-select v-model="$socio.contatto.row.natoa" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._comune" v-if="item.provincia==$socio.contatto.row.natoprovincia" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      
      <div class="col s12" v-if="$socio.contatto.row.natonazione!='ITA'">
      <el-form-item label="Città di nascita" prop="natoa">
        <el-input  v-model="$socio.contatto.row.natoa"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">CASA</div>

      <div class="col s12">
      <el-form-item label="Indirizzo" prop="address">
        <el-input  v-model="$socio.contatto.row.address"></el-input>
      </el-form-item>
      </div>

      <div class="col s12 m6">
      <el-form-item label="CAP" prop="cap">
        <el-input  v-model="$socio.contatto.row.cap"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6">
      <el-form-item label="Città" prop="citta">
        <el-input  v-model="$socio.contatto.row.citta"></el-input>
      </el-form-item>
      </div>       

      <div class="col s12 m6">
      <el-form-item label="Cellulare" prop="cellulare">
        <el-input  v-model="$socio.contatto.row.cellulare"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Telefono" prop="telefono">
        <el-input  v-model="$socio.contatto.row.telefono"></el-input>
      </el-form-item>
      </div> 
<!--
      <div class="col s12">
      <el-form-item label="Country" prop="nazione">
        <el-select v-model="$socio.contatto.row.nazione" filterable placeholder="Choose from the list" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nomeeng" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>
      -->

      <div class="col s12">LAVORO</div>
      <div class="col s12">
      <el-form-item label="Ente" prop="ente">
        <el-input  v-model="$socio.contatto.row.ente"></el-input>
      </el-form-item>
      </div>
<!--
      <div class="col s12">
      <el-form-item label="UO." prop="unitaoperativa">
        <el-input  v-model="$socio.contatto.row.unitaoperativa"></el-input>
      </el-form-item>
      </div>
-->      

      <div class="col s12">
      <el-form-item label="Indirizzo" prop="workaddress">
        <el-input  v-model="$socio.contatto.row.workaddress"></el-input>
      </el-form-item>
      </div>



      <div class="col s12 m6" >
      <el-form-item label="Provincia di lavoro" prop="workprovincia">
        <el-select v-model="$socio.contatto.row.workprovincia" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>


      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Città di lavoro" prop="workcitta">
        <el-select v-model="$socio.contatto.row.workcitta" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._comune" v-if="item.provincia==$socio.contatto.row.workprovincia" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
        </el-select>
      </el-form-item>
      </div>


      <div class="col s12 ">
      <el-form-item label="CAP" prop="workcap">
        <el-input  v-model="$socio.contatto.row.workcap"></el-input>
      </el-form-item>
      </div> 

<!--
      <div class="col s12">
      <el-form-item label="Country" prop="nazionelavoro">
        <el-select v-model="$socio.contatto.row.nazionelavoro" filterable placeholder="Choose from the list" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nomeeng" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      -->
<!--
      <div class="col s12 m6">
      <el-form-item label="Note" :rules="{ required: true, message: 'Le note ledevi scrivere' }" >
        <el-input  v-model="$socio.si.row.note"></el-input>
      </el-form-item>
      </div>
-->

    </div>

    <div class="title_h1 yo-color-primary" style="margin-top:30px;">INFORMATIVA PRIVACY AI SENSI DELL’ ART. 13 DEL REGOLAMENTO EU n. 679/2016</div>
    
    <div class="row pad" style="margin-top:20px;">

      <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authbasic">
        <el-checkbox v-model="$socio.si.row.authbasic" :true-label="authcheck" false-label="" disabled></el-checkbox>
        </el-form-item>
      </div>
      <div class="col s10" style="padding-bottom:20px;padding-top:10px;">
        Si chiede di prendere visione dell' <a :href="'https://www.biomedia.net/gdpr/privacy-'+this.$socio.sigla+'.pdf?'+$teras.random()" target="_blank" style="color:red;font-weight:bold;">informativa privacy</a> dei Soci della {{$socio.sigla}}. 
      </div>

      <div class="col s12 m10 offset-m2">
      Si prega di prestare eventuale consenso facoltativo:
      </div>
        
      <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authcommercial">
        <el-checkbox v-model="$socio.si.row.authcommercial" :true-label="authcheck" false-label=""></el-checkbox>
        </el-form-item>
      </div>
      <div class="col s10" style="padding-bottom:20px;padding-top:10px;">
        Per il trattamento dei dati personali al fine di un eventuale invio di materiale informativo da parte di altre associazioni e/o altri soggetti giuridici aventi interessi comuni con la {{$socio.sigla}}.
      </div>

    </div>





  

    <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m3">
        <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
      </div> 
      <div class="col s12 m4 offset-m5">
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva</el-button>
      </div>
    </div>

  </el-form>
</div>
</template>

<script>

export default {
  name: 'contatto-edit',
  components: {

  },
  created () {
    this.$teras.page.title = (this.$socio.contatto.row.id>0) ? 'Modifica Contatto '+this.$socio.contatto.row.id : 'Nuovo Contatto'
  },
  mounted() {
    this.$socio.si.row.authbasic = this.authcheck
    if(this.$socio.si.row.authcommercial!='0000-00-00')
      this.$socio.si.row.authcommercial = this.authcheck
    /* SOLO PER SIP
    if(this.$socio.si.row.authmaterial!='0000-00-00')
      this.$socio.si.row.authmaterial = this.authcheck
    */
  },
  beforeDestroy () {
  },
  data() {
    return {
      emailcheck:'',
      authcheck: this.$moment().format('YYYY-MM-DD'),
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$socio.contatto.email) {
          return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
        }else{
          callback();
        }
      }
    }
  },
  methods: {
    onChange(editor, content){
      console.log(".................................................................................:"+editor)
      //this.form.note = editor
    },
    onCancel() {
        this.$router.go(-1)
    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })


          var errore = 'no-error'

          if(errore == 'no-error' && this.$socio.contatto.row.email != this.emailcheck)
            errore='L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'

          if(errore == 'no-error' && this.$socio.si.row.authbasic != this.authcheck)
            errore='Bisogna accettare la privacy!'
            
          if(errore == 'no-error' && (this.$socio.contatto.row.natodata=='' || parseInt(this.$moment(this.$socio.contatto.row.natodata).toNow('yy',true))<18))
            errore='Bisogna essere maggiorenni!'

          var emailCHeck = await this.$socio.checkEmail(this.$socio.contatto.row.email,this.$socio.contatto.row.id)
          if(errore == 'no-error' && !emailCHeck)
            errore='L\'indirizzo email risulta già tra i nostri soci, la preghiamo di usarne uno diverso o contattare la segreteria!'

          if(errore != 'no-error'){
            this.loading.close()
            window.scrollTo(0,0);
            this.$notify.error({title: 'Errore',message: errore});
          }else{
            await this.$socio.contatto.save()
            await this.$socio.si.save()
            this.loading.close()
            this.$router.push('/home/')
          }






          
          
        } else {
          window.scrollTo(0,0);
          this.$notify.error({title: 'Errore',message: 'Non tutti i dati sono stati inseriti in maniera corretta, la preghiamo di verificare!'});
          return false
        }
      })
    }

  },
  computed: {
     rules:function() {
      var rulesNow = {
        note: [
          { required: true, message: 'Le note ledevi scrivere' }
        ],
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email corretto', trigger: 'blur,change' }
        ],
        workprovincia: [
          { required: true, message: 'La provincia di lavoro è obbligatorio'}
        ],
        giorno: [
          { required: true, message: 'La data è obbligatoria'}
        ] ,
        cellulare: [
          { required: true, message: 'Il cellulare è obbligatoria'}
        ]      
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>